import { render, staticRenderFns } from "./DialogFooter.vue?vue&type=template&id=556e2cc9&"
import script from "./DialogFooter.vue?vue&type=script&lang=js&"
export * from "./DialogFooter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports